import { api } from 'boot/axios.js'

export async function get(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('devices', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/devices',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function token(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/devices/token',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('token', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export function wsItem(ctx, data) {
  ctx.commit('wsItem', data)
}

export async function me(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/devices/me',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('me', response.data)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}
